const objectValueChecker = (obj, boolean) => {
  const objectValues = Object.values(obj);
  const valueChecker = objectValues.every((value) => value === boolean);

  return valueChecker;
};

export default objectValueChecker;
